module.exports = __webpack_public_path__ + "img/brain-mobile.a8efaed2.png";